<script>
import {mapGetters} from "vuex";
import Loading from "@/components/Loading.vue";
import AnalyticsDetailRow from "@/components/MultiConnect/Analytics/AnalyticsDetailRow.vue";

export default {
  name: "NotesAnalytics",
  components: {AnalyticsDetailRow, Loading},
  computed: {
    ...mapGetters(["currentEvent"])
  },
  methods: {
    view() {
      this.$router.push({
        name: "notesAnalytics",
        params: {
          eventId: this.currentEvent.id,
        }});
    }
  },
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<template>
  <div>
    <v-card :outlined="isPdf ? false : true">

      <v-card-title>Notes</v-card-title>
<!--      <div class="pb-4">
        <v-divider/>
      </div>-->
<!--      <div v-if="eventNotes === null || eventNotes === undefined">
        <Loading/>
      </div>-->
      <div class="px-4 pb-4">
        <AnalyticsDetailRow
            icon="notepad.svg"
            :title="`${this.currentEvent.analyticsData.eventNotes} notes created` " value="" @onView="view" :show-view-button="true"/>
      </div>
    </v-card>
  </div>
</template>

<style scoped>

</style>